// extracted by mini-css-extract-plugin
export var actionButton = "_wj-2";
export var card = "_wj-0";
export var errorCard = "_wj-1";